const PaymentsPage = () => (
  <div className="p-8 bg-white rounded-lg shadow-xl">
    <h2 className="text-3xl font-bold text-gray-800 mb-6">Payments</h2>
    <div className="mb-6 flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-4">
      <input
        type="text"
        placeholder="Search by Member ID or Name"
        className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <button className="bg-blue-600 text-white py-2 px-5 rounded-md hover:bg-blue-700 transition-colors duration-300 font-semibold">
        Search Payments
      </button>
    </div>
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
        <thead>
          <tr className="bg-gray-100 border-b border-gray-200">
            <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
              Transaction ID
            </th>
            <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
              Member Name
            </th>
            <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
              Amount
            </th>
            <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
              Date
            </th>
            <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
              Status
            </th>
            <th className="py-3 px-6 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          <tr>
            <td className="py-4 px-6 whitespace-nowrap">TXN001</td>
            <td className="py-4 px-6 whitespace-nowrap">Alice Wonderland</td>
            <td className="py-4 px-6 whitespace-nowrap">$120.00</td>
            <td className="py-4 px-6 whitespace-nowrap">2025-07-01</td>
            <td className="py-4 px-6 whitespace-nowrap text-green-600 font-semibold">
              Completed
            </td>
            <td className="py-4 px-6 whitespace-nowrap">
              <button className="text-indigo-600 hover:text-indigo-900 mr-3">
                View Details
              </button>
              <button className="text-red-600 hover:text-red-900">
                Refund
              </button>
            </td>
          </tr>
          <tr>
            <td className="py-4 px-6 whitespace-nowrap">TXN002</td>
            <td className="py-4 px-6 whitespace-nowrap">Bob The Builder</td>
            <td className="py-4 px-6 whitespace-nowrap">$300.00</td>
            <td className="py-4 px-6 whitespace-nowrap">2025-06-15</td>
            <td className="py-4 px-6 whitespace-nowrap text-yellow-600 font-semibold">
              Pending
            </td>
            <td className="py-4 px-6 whitespace-nowrap">
              <button className="text-indigo-600 hover:text-indigo-900 mr-3">
                Edit
              </button>
              <button className="text-green-600 hover:text-green-900">
                Mark Paid
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div className="mt-8">
      <h3 className="text-2xl font-semibold text-gray-700 mb-4">
        Record New Payment
      </h3>
      <form className="space-y-2 max-w-xl">
        <div>
          <label
            htmlFor="paymentMemberId"
            className="block text-gray-700 text-sm font-semibold mb-2"
          >
            Member ID:
          </label>
          <input
            type="text"
            id="paymentMemberId"
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>
        <div>
          <label
            htmlFor="paymentAmount"
            className="block text-gray-700 text-sm font-semibold mb-2"
          >
            Amount:
          </label>
          <input
            type="number"
            id="paymentAmount"
            step="0.01"
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>
        <div>
          <label
            htmlFor="paymentMethod"
            className="block text-gray-700 text-sm font-semibold mb-2"
          >
            Payment Method:
          </label>
          <select
            id="paymentMethod"
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
          >
            <option>Cash</option>
            <option>Card</option>
            <option>Bank Transfer</option>
          </select>
        </div>
        <button
          type="submit"
          className="bg-purple-600 text-white py-2 px-6 rounded-md hover:bg-purple-700 transition-colors duration-300 font-semibold"
        >
          Record Payment
        </button>
      </form>
    </div>
  </div>
);

export default PaymentsPage;
